import { useEffect, useState } from "react";

export default function WallStreetLoader() {

  const messages = [
    "Processing Your Loan...",
    "Verifying Documents...",
    "Approving Funds...",
    "Almost Ready..."
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, 1200);

    return () => clearInterval(interval);

  }, []);

  return (

    <div className="preloader">

      <div className="loader-container ">

        {/* Logo */}
        <img
          src="/assets/images/logo.png"
          className="logo-loader"
          alt="Wall Street Finz"
        />

        {/* Brand */}
        <h1 className="brand-text mb-0">
          Wall Street <span>Finz</span>
        </h1>

        {/* Loading Bar */}
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>

        {/* Rotating Text */}
        <p className="loading-text">
          {messages[index]}
        </p>

      </div>

    </div>
  );
}